module.exports = __webpack_public_path__ + "static/logo-bpjs-tk-14315cdc5a7caadeedebbc9dba667208.png";